export default "__VITE_ASSET__D93TFOC$__"